.rightImage {
    max-width: 100%;
    max-height: 100%;
}

.input_text {
    width: 100%;
    height: 40px;
    padding: 0 32px 0 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    background: white;
    line-height: 40px;
    display: flex;
    align-items: center;
    &::placeholder {
        color: #666;
    }

    &:focus {
        outline: none;
        border-color: #4a90e2;
    }
    margin-bottom: 10px;
}

.input_textarea {
    padding-top: 6px !important;
    resize: none;
    height: 80px !important;
    line-height: 1.25 !important;
}
.label {
    font-family: Hanken Grotesk;
    font-weight: 700;
    color: #102442;
    margin-bottom: 6px;
    font-size: 14px;
}

.addButton {
    background: #4285f4 !important;
    border: none !important;
    border-radius: 8px !important;
    color: white !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;

    &:hover {
        background: #3367d6 !important;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
        transform: translateY(-1px) !important;
    }

    &:active {
        background: #2851a3 !important;
        transform: translateY(0) !important;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    }
}
